(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Ricerca',
    noCollectionFound: 'Non ci sono collezioni',
    allProducts: 'Vedi tutti i prodotti',
    matching: 'risultati',
    sortBy: 'Ordina per',
    relevance: 'Rilevanza',
    mostPopular: 'Più Venduti',
    outOf: 'Su',
    resultsFound: 'risultati',
    oneResultFound: 'C\'è un solo risultato per questa ricerca',
    noResultFound: 'Non ci sono risultati per questa ricerca',
    addToCart: 'Add to cart',
    searchForProduct: 'Scrivi per iniziare la ricerca',
    selectedFilter: 'Filtri selezionati',
    clearAll: 'Rimuovi i filtri',
    noPageFound: 'Nessuna pagina trovata',
    outOfStock: 'Fuori Magazzino',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Non ci sono risultati per la ricerca ' + render(text);
    },
    
    /*
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },
    */

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Prova ' +
        render(html_tags[0]) +
        ' a rimuovere i filtri ' +
        render(html_tags[1]) +
        ' o ' +
        render(html_tags[2]) +
        ' con una nuova ricerca ' +
        render(html_tags[3])
      );
    },

    /*
    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' su'
      );
    },
    */

    many_Results: function(text, render) {
      if (this.nbHits > 1 && this.nbHits <= 100) {
        return this.nbHits + ' risultati trovati'
      }
      else {
        return 'Più di 100 risultati trovati'
      }
    },

    by: function(text, render) {
      return 'di ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
